<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('推送账号')">
              <a-input :placeholder="$t('请输入推送账号')" v-model="queryParam.sendCode"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('推送类型')">
              <a-select :placeholder="$t('请输入推送类型')" v-model="queryParam.sendType">
                <a-select-option :value="0">
                  {{ $t('短信') }}
                </a-select-option>
                <a-select-option :value="1">
                  {{ $t('微信') }}
                </a-select-option>
              </a-select>
              <!-- <a-input placeholder="请输入推送类型(0:短信,1:微信)" v-model="queryParam.sendType"></a-input> -->
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('设备类型')">
              <a-select :placeholder="$t('请输入设备类型')" v-model="queryParam.deviceType">
                <a-select-option :value="0">
                  {{ $t('水表') }}
                </a-select-option>
                <a-select-option :value="1">
                  {{ $t('水质监测') }}
                </a-select-option>
                <a-select-option :value="2">
                  {{ $t('压力液位') }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('激活状态')">
                <a-select :placeholder="$t('请输入激活状态')" v-model="queryParam.sendActive">
                  <a-select-option :value="0">
                    {{ $t('未激活') }}
                  </a-select-option>
                  <a-select-option :value="1">
                    {{ $t('激活') }}
                  </a-select-option>
                </a-select>
                <!-- <a-input placeholder="请输入激活状态(0:未激活,1:激活)" v-model="queryParam.sendActive"></a-input> -->
              </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('新增') }}</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('wq_message_rev_person')">{{ $t('导出') }}</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">{{ $t('导入') }}</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>
    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;" v-if="selectedRowKeys.length > 0">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
      </div>
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
          <a-divider type="vertical" />
          <a @click="handleDetail(record)">{{ $t('详情') }}</a>
          <a-divider type="vertical" />
          <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record.id)">
            <a>{{ $t('删除') }}</a>
          </a-popconfirm>
          <!-- <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown> -->
        </span>
      </a-table>
    </div>
    <wq-message-rev-person-modal ref="modalForm" @ok="modalFormOk"></wq-message-rev-person-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {isUndefined} from'@/utils/validate'
  import WqMessageRevPersonModal from './modules/WqMessageRevPersonModal'

  export default {
    name: 'WqMessageRevPersonList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      WqMessageRevPersonModal
    },
    data () {
      return {
        description: 'wq_message_rev_person管理页面',
        url: {
          list: "/wq/wQMessageRevPerson/list",
          delete: "/wq/wQMessageRevPerson/delete",
          deleteBatch: "/wq/wQMessageRevPerson/deleteBatch",
          exportXlsUrl: "/wq/wQMessageRevPerson/exportXls",
          importExcelUrl: "wq/wQMessageRevPerson/importExcel",
        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },{
            title: this.$t('推送账号'),
            align:"center",
            dataIndex: 'sendCode'
          },{
            title: this.$t('推送类型'),
            align:"center",
            dataIndex: 'sendType',
            customRender: (t,r,index) => {
              let data = {"0": this.$t("短信"),"1": this.$t("微信")}
              if(isUndefined(typeof data[t])) {
                return this.$t("其他")
              }
              return data[t]
            }
          },{
            title: this.$t('设备类型'),
            align:"center",
            dataIndex: 'deviceType',
            customRender: (t,r,index) => {
              let data = {"0": this.$t("水表"),"1": this.$t("水质监测"),"2": this.$t("压力液位")}
              if(isUndefined(typeof data[t])) {
                return this.$t("其他")
              }
              return data[t]
            }
          },{
            title: this.$t('激活状态'),
            align:"center",
            dataIndex: 'sendActive',
            customRender: (t,r,index) => {
              let data = {"0": this.$t("未激活"),"1": this.$t("激活")}
              if(isUndefined(typeof data[t])) {
                return this.$t("其他")
              }
              return data[t]
            }
          },{
            title: this.$t('创建人'),
            align:"center",
            dataIndex: 'createBy'
          },{
            title: this.$t('创建时间'),
            align:"center",
            dataIndex: 'createTime'
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:160,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      initDictConfig(){
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
